//@ts-check
import { parseHtml } from 'helpers';
// @ts-ignore
import stylesCourse from 'styles/Course.module.scss';
import React from 'react';

const FillInTheBlankMarking = ({ result }) => {
  return (
    <>
      <div className="whiteSpacePre foo freetext-correct-ans-align">
        <div>
          <div
            className={
              `flexRow ${stylesCourse['item-section-normal']}` +
              ` ${stylesCourse['item-section-enabled']}`
            }
            style={{
              // @ts-ignore
              '--labelcolor': '#c1c9d4',
            }}
          >
            <span className="fill-blank w-100 px-md-2 px-05 py-05">
              {parseHtml(
                result?.modifiedContent,
                'fill-in-the-blank pr-1 fill-overflow-image',
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default FillInTheBlankMarking;
